module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_crystal_small.aaa10536.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_crystal_small.png
// module id = 3000
// module chunks = 11